// extracted by mini-css-extract-plugin
module.exports = {"Divider":"style_Divider__7IFjN"};